import { render, staticRenderFns } from "./updateLinkageDesc.vue?vue&type=template&id=c22294d4&lang=pug"
import script from "./updateLinkageDesc.vue?vue&type=script&lang=js"
export * from "./updateLinkageDesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports